// src/apiUrls.js
const BASE_URL = 'https://14starsfarm.com/cashbook/Backend/api'

const API_URLS = {
  AUTH: `${BASE_URL}/auth.php`,
  CHECK_AUTH: `${BASE_URL}/check_auth.php`,
  ADMIN_USERS: `${BASE_URL}/admin_users.php`,
  ENTRIES: `${BASE_URL}/entries.php`,
  REGISTER: `${BASE_URL}/register.php`,
  LOGOUT: `${BASE_URL}/logout.php`,
  USER_PERMISSIONS: `${BASE_URL}/user_permissions.php`,
  USER_CATEGORIES: `${BASE_URL}/user_categories.php`,
  CATEGORIES: `${BASE_URL}/categories.php`,
  CATEGORY_MANAGEMENT: `${BASE_URL}/category_management.php`
}

export default API_URLS
